module.exports = __webpack_public_path__ + "static/media/whitestar.e97f2d4f.webp";